import { render } from "./ActCompleted.vue?vue&type=template&id=56d5b76e"
import script from "./ActCompleted.vue?vue&type=script&lang=js"
export * from "./ActCompleted.vue?vue&type=script&lang=js"

import exportComponent from "P:\\htdocs\\we-smile\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__